import script from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"

import "./CostBreakdownView.vue?vue&type=style&index=0&id=c99b073a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c99b073a"]])

export default __exports__